import {EmulatorMessage} from '../../../../../shared/models/emulator';

export const isTranslate = (
    emulatorMessage: EmulatorMessage
): EmulatorMessage => {
    if ('channelPayload' in emulatorMessage) {
        // TODO This might be a json String
        return eventDelegator(emulatorMessage);
    }
    return text(emulatorMessage);
};

const eventDelegator = (emulatorMessage: EmulatorMessage): EmulatorMessage => {
    const payload = emulatorMessage['channelPayload'];
    if ('messages' in payload) {
        return messagePayload(emulatorMessage, payload);
    }
    if ('event' in payload) {
        return eventPayload(emulatorMessage, payload);
    }

    return text(emulatorMessage);
};

const messagePayload = (emulatorMessage: EmulatorMessage, payload): EmulatorMessage => {
    const message = payload['messages'][0];

    if (message['channel'] === 'whatsapp') {
        if (message['media']) {
            return media(emulatorMessage, message);
        }
        if (message['location']) {
            return location(emulatorMessage, message);
        }
        if (message['button']) {
            return button(emulatorMessage, message);
        }
        if (message['listPicker']) {
            return listPicker(emulatorMessage);
        }
        if (message['contacts']) {
            return contacts(emulatorMessage, message);
        }
        if (message['locationRequest']) {
            return locationRequest(emulatorMessage, message);
        }
        if (message['actionUrl']) {
            return callToAction(emulatorMessage, message);
        }
        return text(emulatorMessage);
    } else {
        return text(emulatorMessage);
    }
};



const eventPayload = (emulatorMessage: EmulatorMessage, payload): EmulatorMessage => {
    const event = payload['event'];

    if ('messageStatusUpdate' in event) {
        return messageStatusEvent(emulatorMessage, event);
    }

    throw Error('Event type not supported');
};

const messageStatusEvent = (emulatorMessage: EmulatorMessage, event): EmulatorMessage => {

    const messageStatusUpdate = event['messageStatusUpdate'][0];
    const status = messageStatusUpdate['statusCode'];

    let statusCode = 'error';

    switch (status) {
        case 4: // SENT_TO_SUPPLIER
            statusCode = 'send';
            break;
        case 5: // DEVICE_ACK
            statusCode = 'deliver';
            break;
        case 1001: // READ
            statusCode = 'read';
            break;
    }

    emulatorMessage.mediaMetaData = {
        src: '',
        status: statusCode,
        messageId: messageStatusUpdate['messageId'],
        bubbleType: 'notification',
    };
    return emulatorMessage;
};

const media = (emulatorMessage: EmulatorMessage, message) => {
    const ref = message['media']['fileId'];
    const metaData = emulatorMessage['channelPayload']['emulatorFiles'][ref];
    const type = metaData['type'].split('/')[0];
    switch (type) {
        case 'image':
            return image(emulatorMessage, metaData);
        case 'video':
            return video(emulatorMessage, metaData);
        case 'application':
            return application(emulatorMessage, metaData);
        case 'audio':
            return audio(emulatorMessage, metaData);
    }
    return;
};


const image = (emulatorMessage: EmulatorMessage, metaData): EmulatorMessage => {
  let description = '';
  if (emulatorMessage['channelPayload']['messages'][0]['media'] && emulatorMessage['channelPayload']['messages'][0]['media']['caption']) {
    description = emulatorMessage['channelPayload']['messages'][0]['media']['caption'];
  }
    emulatorMessage.mediaMetaData = {
        src: metaData['src'],
        description: description,
        bubbleType: 'image',
    };
    return emulatorMessage;
};

const video = (emulatorMessage: EmulatorMessage, metaData): EmulatorMessage => {
    let description = '';
    if (emulatorMessage['channelPayload']['messages'][0]['media'] && emulatorMessage['channelPayload']['messages'][0]['media']['caption']) {
        description = emulatorMessage['channelPayload']['messages'][0]['media']['caption'];
    }
    emulatorMessage.mediaMetaData = {
        src: metaData['src'],
        type: metaData['type'],
        bubbleType: 'video',
        description: description
    };
    return emulatorMessage;
};

const application = (emulatorMessage: EmulatorMessage, metaData): EmulatorMessage => {
    emulatorMessage.mediaMetaData = {
        type: metaData['type'],
        src: metaData['src'],
        description: metaData['name'],
        fileSize: metaData['size'],
        bubbleType: 'file',
    };
    return emulatorMessage;
};

const audio = (emulatorMessage: EmulatorMessage, metaData): EmulatorMessage => {
    emulatorMessage.mediaMetaData = {
        src: metaData['src'],
        bubbleType: 'voicenote',
    };
    return emulatorMessage;
};


const location = (emulatorMessage: EmulatorMessage, message): EmulatorMessage => {
    emulatorMessage.mediaMetaData = {
        locationName: message['location'].name,
        locationAddress: message['location'].address,
        latitude: message['location'].latitude,
        longitude: message['location'].longitude,
        src: '',
        bubbleType: 'location',
    };
    return emulatorMessage;
};

const button = (emulatorMessage: EmulatorMessage, message): EmulatorMessage => {
    if (message['button']['header'] && message['button']['header']['media']) {
      const ref = message['button']['header']['media']['fileId'];
      const metaData = emulatorMessage['channelPayload']['emulatorFiles'][ref];
      const type = metaData['type'].split('/')[0];
      switch (type) {
        case 'image':
          emulatorMessage = image(emulatorMessage, metaData);
          break;
        case 'video':
          emulatorMessage = video(emulatorMessage, metaData);
          break;
        case 'application':
          emulatorMessage = application(emulatorMessage, metaData);
          break;
      }
    } else {
      emulatorMessage.mediaMetaData = {
        src: '',
        ...emulatorMessage.mediaMetaData
      };
    }
    emulatorMessage.mediaMetaData['bubbleType'] = 'button';
    return emulatorMessage;
};

const listPicker = (emulatorMessage: EmulatorMessage): EmulatorMessage => {
    emulatorMessage.mediaMetaData = {
        src: '',
        bubbleType: 'list',
    };
    return emulatorMessage;
};

const locationRequest = (emulatorMessage: EmulatorMessage, message): EmulatorMessage => {
    emulatorMessage.mediaMetaData = {
        src: '',
        bubbleType: 'requestlocation',
    };
    return emulatorMessage;
};

const callToAction = (emulatorMessage: EmulatorMessage, message): EmulatorMessage => {
    const actionUrl = message['actionUrl'];
    emulatorMessage.mediaMetaData = {
        src: '',
        bubbleType: 'actionUrl',
        actionUrl: actionUrl
    };
    return emulatorMessage;
};

const text = (emulatorMessage: EmulatorMessage): EmulatorMessage => {
    emulatorMessage.mediaMetaData = {
        src: '',
        bubbleType: 'text',
    };
    return emulatorMessage;
};

const contacts = (emulatorMessage: EmulatorMessage, message): EmulatorMessage => {
    const contacts = message['contacts'][0];
    emulatorMessage.mediaMetaData = {
        src: "",
        messageId: "",
        bubbleType: "contact",
        contacts
    };
    return emulatorMessage;
};